import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useDepreciationApi() {
  const callApi = useApiCall();

  const GetDepreciationMethods = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.METHODS, data, onSuccess, onError);
  }
  const GetDepreciationApportions = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.APPORTIONS, data, onSuccess, onError);
  }
  const GetList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.LIST, data, onSuccess, onError);
  }

  const Save = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.SAVE, data, onSuccess, onError);
  }

  const Delete = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.DELETE, data, onSuccess, onError);
  }

  const GetUsefulLifeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_USEFUL_LIST, data, onSuccess, onError);
  }

  const GetConventionPercentageList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_CONVENTION_PERCENTAGE_LIST, data, onSuccess, onError);
  }

  const GetDepreciationConventionTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_CONVENTION_TYPE_LIST, data, onSuccess, onError);
  }

  const GetGAAPDepreciation = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_GAAP, data, onSuccess, onError);
  }
  const GetRevaluationList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_REVALUATION_LIST, data, onSuccess, onError);
  }

  const GetDisposalList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_DISPOSAL_LIST, data, onSuccess, onError);
  }
  const GetMCARSDepreciation = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_MCARS_DEPRECIATION, data, onSuccess, onError);
  }
  
  const SaveAssetDepreciation = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.SAVE_ASSET_DEPRECIATION, data, onSuccess, onError);
  }

  const ValidateMCARSTransaction = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.VALIDATE_MARS_TRANSACTION, data, onSuccess, onError);
  }

  const GetAssetBookValue = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_ASSET_BOOK_VALUE, data, onSuccess, onError);
  }

  const SaveRevaluation = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.SAVE_REVALUATION, data, onSuccess, onError);
  }
  const SaveRevaluationAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.SAVE_REVALUATION_ATTACHMENT, data, onSuccess, onError);
  }

  const GetDisposalTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_DISPOSAL_TYPE_LIST, data, onSuccess, onError);
  }
  const SaveDisposal = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.SAVE_DISPOSAL, data, onSuccess, onError);
  }
  const SaveDisposalAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.SAVE_DISPOSAL_ATTACHMENT, data, onSuccess, onError);
  } 

  const GetCurrentUsefullife = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_CURRET_USERFUL_LIFE, data, onSuccess, onError);
  }
  const GetAssetDepreciationList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_ASSET_DEPRECIATION_LIST, data, onSuccess, onError);
  }
  const GetDepreciationReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_DEPRECIATION_REPORT, data, onSuccess, onError);
  }
  const AllAssetDepreciationExportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.ALL_ASSET_DEPRECIATION_EXPORT_TO_XLS, data, onSuccess, onError);
  }
  
  const ExportDepreciationReportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.DEPRECIATION_REPORT_EXPORT_TO_XLS, data, onSuccess, onError);
  }

  const GetAuditorReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.GET_AUDITOR_REPORT, data, onSuccess, onError);
  }

  const ExportAuditorReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DEPRECIATION.AUDITOR_REPORT_EXPORT_TO_XLS, data, onSuccess, onError);
  }


  return {
    GetDepreciationMethods,
    GetDepreciationApportions,
    GetList,
    Save,
    Delete,
    GetUsefulLifeList,
    GetConventionPercentageList,
    GetDepreciationConventionTypeList,
    GetGAAPDepreciation,
    GetRevaluationList,
    GetDisposalList,
    GetMCARSDepreciation,
    SaveAssetDepreciation,
    ValidateMCARSTransaction ,
    GetAssetBookValue,
    SaveRevaluation,
    SaveRevaluationAttachment,
    GetDisposalTypeList,
    SaveDisposal,
    SaveDisposalAttachment,
    GetCurrentUsefullife,
    GetAssetDepreciationList,
    GetDepreciationReport,
    AllAssetDepreciationExportToXLS,
    ExportDepreciationReportcsv,
    GetAuditorReport,
    ExportAuditorReportToXLS
  };
}
